<template>
  <div class="analytics">
    <analytic-distribution
      class="analytics__bloc"
      :chart="dataAnalytics[currentKpi]"
      v-if="dataAnalytics && dataAnalytics[currentKpi] && Object.keys(dataAnalytics[currentKpi]).length !== 0"
    ></analytic-distribution>
    <analytic-review
      class="analytics__bloc"
      :chart="dataAnalytics[currentKpi]"
      v-if="dataAnalytics && dataAnalytics[currentKpi] && Object.keys(dataAnalytics[currentKpi]).length !== 0"
    ></analytic-review>
    <div
      class="analytics__bloc analytics__bloc--full"
      v-if="!dataAnalytics || !dataAnalytics[currentKpi] || Object.keys(dataAnalytics[currentKpi]).length === 0"
    >
      {{ $t('analytics.noData') }}
    </div>
    <!-- Filters Button -->
    <transition name="fade">
      <ui-button
        class="analytics__filters-button"
        :label="$t('radar.actions.filters')"
        button="cta"
        icon="filter"
        :iconOnly="true"
        v-tooltip="{
          placement: 'top',
          trigger: 'hover',
          content: $t('radar.actions.filters'),
          offset: 3,
        }"
        v-if="!noUi"
        @click.prevent="toggleFilters(true)"
      />
    </transition>
    <!-- Filters Sidebar -->
    <transition :name="isMobile ? 'slide-right' : 'scale-tr'">
      <filters
        class="analytics__filters"
        v-show="filters.active && !noUi"
        @refreshLocations="$emit('refreshLocations')"
        @refreshFilters="$emit('refreshFilters')"
      />
    </transition>
    <!-- Timeline Button -->
    <transition name="fade">
      <ui-button
        class="analytics__timeline-button"
        :label="$t('gmap.actions.timeline')"
        button="cta"
        icon="timeline"
        :iconOnly="true"
        v-tooltip="{
          placement: 'top',
          trigger: 'hover',
          content: $t('gmap.actions.timeline'),
          offset: 3,
        }"
        v-if="!timeline.active && !noUi && timelineKpi.length > 1"
        @click.prevent="toggleTimeline(true)"
      />
    </transition>
    <!-- Timeline Sidebar -->
    <transition :name="isMobile ? 'slide-right' : 'scale-tr'">
      <timeline
        class="analytics__timeline"
        v-show="timeline.active && !noUi"
        :timeline-kpi="timelineKpi"
        @refreshLocations="$emit('refreshAnalytics')"
      />
    </transition>
    <!-- Settings Button -->
    <transition name="fade">
      <ui-button
        class="analytics__settings-button"
        :label="$t('radar.actions.settings')"
        button="cta"
        icon="settings"
        :iconOnly="true"
        v-tooltip="{
          placement: 'top',
          trigger: 'hover',
          content: $t('radar.actions.settings'),
          offset: 3,
        }"
        v-if="!noUi"
        @click.prevent="openSettings"
      />
    </transition>
    <!-- Settings Modal -->
    <settings />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import UiButton from '@/components/UI/Button.vue'
import AnalyticDistribution from '@/components/Analytic/Distribution.vue'
import AnalyticReview from '@/components/Analytic/Review.vue'
import Filters from '@/components/Filters.vue'
import Settings from '@/components/Settings.vue'
import Timeline from '@/components/Timeline.vue'
import { isMobile } from '@/utils/navigator.util'

export default {
  name: 'Analytics',
  components: {
    UiButton,
    AnalyticDistribution,
    AnalyticReview,
    Filters,
    Settings,
    Timeline,
  },
  data() {
    return {
      isMobile: isMobile(),
    }
  },
  mounted() {
    this.toggleFilters(false)
  },
  computed: {
    ...mapState({
      dataAnalytics: state => state.data.analytics,
      brandSettings: state => state.data.settings,

      filters: state => state.radar.filters,
      noUi: state => state.radar.noUi,
      timeline: state => state.radar.timeline,

      currentKpi: state => state.refine.currentKpi,
    }),
    timelineKpi() {
      return this.brandSettings.find(s => s.key === this.currentKpi).timelapse || []
    },
  },
  methods: {
    ...mapActions({
      toggleFilters: 'radar/toggleFilters',
      toggleTimeline: 'radar/toggleTimeline',
    }),
    openSettings() {
      this.$modal.show('settings')
    },
  },
}
</script>

<style lang="scss" scoped>
.analytics {
  position: absolute;
  top: 0;
  width: 100%;
  height: calc(100% - #{$gmap-views-height});
  overflow-y: auto;

  @media (min-width: $screen-sm) {
    display: flex;
    flex-wrap: wrap;
    background-color: $generic-color-bg-disabled;
    padding: $gutter-md / 2 $gutter-md / 2 80px;
    height: 100%;
  }

  &__bloc {
    @media (min-width: $screen-sm) {
      margin: 12px;
      width: calc(100% - #{$gutter-md * 2} - #{$button-min-height-desktop});
      height: calc(50% - #{$gutter-md});
    }

    @media (min-width: $screen-md) {
      width: calc((100% - #{$gutter-md * 2} - #{$button-min-height-desktop}) / 2 - #{$gutter-md / 2});
      height: calc(100% - #{$gutter-md});
    }

    &--full {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      font-size: 1.125rem;
      font-weight: bold;
    }
  }

  &__settings-button {
    position: fixed;
    top: $gutter-sm / 2;
    right: 128px;
    z-index: 3;

    @media (min-width: $screen-sm) {
      top: 160px;
      right: $gutter-md;
    }
  }

  &__filters-button {
    position: fixed;
    top: $gutter-sm / 2;
    right: 68px;
    z-index: 3;

    @media (min-width: $screen-sm) {
      top: 92px;
      right: $gutter-md;
      bottom: initial;
    }
  }

  &__timeline-button {
    position: fixed;
    top: $gutter-sm / 2;
    right: $gutter-sm / 2;
    z-index: 3;

    @media (min-width: $screen-sm) {
      top: $gutter-md;
      right: $gutter-md;
      bottom: initial;
    }
  }
}
</style>
